import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'lib-havij',
  template: `
    <p>
      {{havij}}
    </p>

    <button (click)="emitHavij()"> Click Me Havij Oskol </button>
  `,
  styles: []
})
export class HavijComponent implements OnInit {

  @Input() havij : string;
  @Output() havijOutput : EventEmitter<string> = new EventEmitter<string>();
  constructor() { }

  ngOnInit() {
  }

  emitHavij(){
    this.havijOutput.emit('Havij Clicked');
  }

}
